// extracted by mini-css-extract-plugin
module.exports = {"newsList":"_4V5YoL","link":"WG8_Wa","item":"_NyHJ_","date":"KoTRB2","title":"nlkxIO","name":"wgdAHI"};